module.exports = __webpack_public_path__ + "static/media/joinus.0f696ecf.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/joinUs/images/joinus.png
// module id = 148
// module chunks = 0